const downloadExtensions = [
    '.pdf',
    '.zip',
    '.docx',
    '.xlsx',
    '.png',
    '.jpg',
    '.jpeg',
    '.gif',
    '.webp',
    '.svg',
    '.mp4',
    '.mp3',
    '.wav',
    '.avi',
    '.mov',
    '.wmv',
    '.flv',
    '.wma',
];

export default (link, label) => {
    const isInternal = link?.linktype === 'story';

    let icon = 'arrow-up-right';

    if (isInternal) {
        icon = 'chevron-right';
    }

    if (downloadExtensions.some((extension) => link?.cached_url?.includes(extension))) {
        icon = 'arrow-up-right';
    }

    const baseData = {
        link: link.cached_url === 'home' ? '/' : link.cached_url,
        text: label,
        isInternal: link?.linktype === 'story',
        rawLink: link,
    };
    return {
        ...link,
        ...baseData,
        icon,
    };
};
